import { Formik } from 'formik';
import { StatusCodes } from 'http-status-codes';
import jwtDecode from 'jwt-decode';
import React, { useContext, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import * as yup from 'yup';
import styled from 'styled-components';
import { Colors, Height } from '../../../scss/common/style';
import FormRow from '../../../components/common/forms/Row/FormRow';
import TextInputComponent from '../../../components/common/forms/TextInput/TextInputComponent';
import WhitePad from '../../../components/common/WhitePad/WhitePad';
import AuthApi from '../../../services/api/AuthApi';
import MyContext from '../../../services/context';
import UserLocalService from '../../../services/logic/userService';
import loginBG from '../../../static/img/LoginBG.png';
import logo from '../../../static/img/LogoLP.png';
import LinkButton from '~/src/components/common/forms/Button/LinkButton';
import PrimaryAlternativeButton from '~/src/components/common/forms/Button/PrimaryAlternativeButton';
import CheckboxInputComponent from '~/src/components/common/forms/CheckboxInput/CheckboxInputComponent';

export default function LoginPage(): JSX.Element {
  const history = useHistory();
  const context = useContext(MyContext);
  const [isChecked, setIsChecked] = useState(false);

  const handleClick = () => {
    setIsChecked(!isChecked);
  };

  const validationSchema = yup.object().shape({
    password: yup.string().required('Password is required'),
    email: yup.string().email('Valid email is required').required('Email is required'),
  });

  const onLogin = async (values, setSubmitting) => {
    try {
      const res = await AuthApi.getServerToken(values.email, values.password);
      if (res.status === StatusCodes.OK) {
        const resJson = res.data;
        const decoded = jwtDecode(resJson.access_token);
        const accessToken = resJson.access_token;
        const refreshToken = resJson.refresh_token;
        UserLocalService.setUser({
          accessToken,
          refreshToken,
          sub: decoded.sub,
          firstName: decoded.given_name,
          lastName: decoded.family_name,
          email: decoded.email,
        }); // so that getUserInfo can get it and use it.
        // Call to get role:
        const resUserInfo = await AuthApi.getUserInfo();
        if (resUserInfo.status === StatusCodes.OK) {
          const resInfoJson = resUserInfo.data;
          const userFromDb = {
            isAuthenticated: true,
            sub: resInfoJson.sub,
            id: resInfoJson.sub,
            firstName: resInfoJson.first_name,
            lastName: resInfoJson.last_name,
            email: resInfoJson.email,
            role: resInfoJson.role,
          };
          context.setUser(userFromDb);
          await UserLocalService.updateUser(userFromDb);
          history.push('/home');
        }
      }
    } catch (error) {
      // error is returned from request method
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Wrapper>
      <BackgroundImage />
      <Formik
        style={{ zIndex: '2' }}
        initialValues={{
          email: '',
          password: '',
        }}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => onLogin(values, setSubmitting)}
      >
        {({
          values,
          errors,
          // touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          // setFieldValue,
          /* and other goodies */
        }) => (
          <div className="row align-items-center h-100">
            <div className="col-sm-6 mx-auto">
              <StyledWrapper className="jumbotron align-items-left">
                <Logo src={logo} />
                <form onSubmit={handleSubmit} autoComplete="off">
                  <StyledRow>
                    <TextInputComponent
                      name="email"
                      label="E-mail"
                      value={values.email}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={12}
                      colorLabel="#B4B4B4"
                    />
                  </StyledRow>
                  <StyledRow>
                    <TextInputComponent
                      name="password"
                      label="Password"
                      value={values.password}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type="password"
                      password
                      cols={12}
                      colorLabel="#B4B4B4"
                    />
                  </StyledRow>
                  <div style={{ marginBottom: 40, marginTop: 15 }}>
                    {/* <CheckboxInputComponent
                      onChange={handleClick}
                      checked={isChecked}
                      label="Remember password"
                      name="rememberPassword"
                      cols={12}
                    /> */}
                  </div>
                  <StyledRow style={{ width: '100% !important', marginBottom: '20px' }}>
                    <PrimaryAlternativeButton
                      style={{ textAlign: 'center' }}
                      width="100% !important"
                      variant="primary"
                      type="submit"
                      isSubmitting={isSubmitting}
                      title="Login"
                    />
                  </StyledRow>
                  <div className="form-group">
                    <LinkButton
                      onClick={(): void => history.push('/password/reset')}
                      type="submit"
                      isSubmitting={isSubmitting}
                      title="Forgot Password?"
                      variant="link"
                    />
                  </div>
                </form>
              </StyledWrapper>
            </div>
          </div>
        )}
      </Formik>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  overflow: hidden;
`;

const StyledRow = styled.div`
  margin-bottom: 10px;
  width: 100%;
  .form-group {
    padding: 0;
  }
`;

const Logo = styled.img`
  width: 150px;
  height: auto;
  margin-bottom: 40px;
`;

const StyledWrapper = styled.div`
  position: relative;
  z-index: 5;
  margin-top: ${Height.mt50};
  text-align: center;
  background-color: ${Colors.white};
  border-radius: 0;
  width: 400px;
  padding: 40px 93px 40px 56px;
  border-radius: 20px;
`;

const BackgroundImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-image: url(${loginBG});
`;
